import classNames from 'classnames';
import { forwardRef } from 'react';
import { UserInfoAvatar } from 'features/user_profiles';
const containerSmallGapsCss = "cz7rc7z";
const containerBigGapsCss = "czh7u0a";
const containerCss = "c1pe19a2";
const Container = forwardRef((props, ref) => {
  const {
    smallGaps,
    bigGaps,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerSmallGapsCss]: smallGaps,
    [containerBigGapsCss]: bigGaps
  }, props.className)} />;
});
const subsectionWrapperHasErrorCss = "s17c9bs5";
const subsectionWrapperIsDashedCss = "s125e8rb";
const subsectionWrapperCss = "s10hwuzq";
const SubsectionWrapper = forwardRef((props, ref) => {
  const {
    hasError,
    isDashed,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subsectionWrapperCss, {
    [subsectionWrapperHasErrorCss]: hasError,
    [subsectionWrapperIsDashedCss]: isDashed
  }, props.className)} />;
});
const listWrapperCss = "l1dywxwq";
const ListWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(listWrapperCss, props.className)} />;
});
const itemWrapperCss = "i1qf607n";
const ItemWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(itemWrapperCss, props.className)} />;
});
const itemDetailsCss = "i1ke2uia";
const ItemDetails = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(itemDetailsCss, props.className)} />;
});
const styledUserInfoAvatarSpacelessCss = "s1es53rs";
const styledUserInfoAvatarCss = "sd7e5q6";
const StyledUserInfoAvatar = forwardRef((props, ref) => {
  const {
    spaceless
  } = props;
  return <UserInfoAvatar ref={ref} {...props} className={classNames(styledUserInfoAvatarCss, {
    [styledUserInfoAvatarSpacelessCss]: spaceless
  }, props.className)} />;
});
const textContainerCss = "tpl9rfl";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, props.className)} />;
});
const addButtonWrapperCss = "a1vg9qok";
const AddButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(addButtonWrapperCss, props.className)} />;
});
const removeButtonWrapperCss = "rea10si";
const RemoveButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(removeButtonWrapperCss, props.className)} />;
});
export { Container, SubsectionWrapper, ListWrapper, ItemWrapper, ItemDetails, StyledUserInfoAvatar, TextContainer, RemoveButtonWrapper, AddButtonWrapper };

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");